export default __webpack_public_path__ + "src/docs/packages/monte-vista-boutique-hotel.pdf";